import React, { useContext, useEffect, useState } from "react";
import {connect} from "react-redux";
import { Icon, Segment, Button, Modal, Header, Form, Step, Flag } from "semantic-ui-react";
import GlobalContext from '../../contexts/GlobalContext';
import { isMobile } from 'react-device-detect';
import InputSelect from "../FormInputCustomer/InputSelect/InputSelect";
import InputText from "../FormInputCustomer/InputText/InputText";
import { toast } from "react-toastify";
import API, { ErrorManagement, ResponseManagement } from "../../API";
import MomentCustomer from './../MomentCustomer/MomentCustomer';
import InputSelectDate from "../FormInputCustomer/InputSelect/InputSelectDate";
import Utility from "../../Utility";
import * as GlobalType from "../../contexts/GlobalType";
import ModalTransition from "../ModalTransition/ModalTransition";
import { formFieldValue, formFieldPartOne, formFieldPartTwo, listErrorInputPartOne, listErrorInputPartTwo } from './configFormField';
import useFromSelfCheckin from "../../hooks/useFromSelfCheckin";
import useRouter from "../../hooks/useRouter";

const mapProps = (state) => ({
    bookingsCompletionRates: state.booking.bookingsCompletionRates,
    isBookerPax: state.booking.isBookerPax
})
const mapDispatch = (dispatch) => ({
    loadBooking: dispatch.booking.load,
    updateBookingsCompletionRate: dispatch.booking.updateBookingsCompletionRateAsync,
    updateIsBookerPax: dispatch.booking.updateIsBookerPax
})

const ModalPreCheckIn = props => {
    const [globalContext, dispatch] = useContext(GlobalContext);
    const [segmentModalState, setSegmentModalState] = useState(null);
    const [showBtnProceedState, setShowBtnProceedState] = useState(null);
    const [showBtnSubmitState, setShowBtnSubmitState] = useState(null);
    const [countriesState, setListPaysState] = useState([]);
    const [listFieldCheckInState, setListFieldCheckInState] = useState({});
    const [formFieldState, setFormFieldState] = useState(formFieldValue);
    const [paramModalState, setParamModalState] = useState({ stepNumber: 0, active: "type" });
    const [identityState, setIdentityState] = useState("");
    const [typeState, setTypeState] = useState("");
    const [startModalState, setStartModalState] = useState(true);
    const [hasDataState, setHasDataState] = useState(false);
    const [errorInputPartOneState, setErrorInputPartOneState] = useState(listErrorInputPartOne);
    const [errorInputPartTwoState, setErrorInputPartTwoState] = useState(listErrorInputPartTwo);
    const [typeForFieldCheckInState, setTypeForFieldCheckInState] = useState("");
    const [listLanguageState, setListLanguageState] = useState([]);
    const [identityDocumentIdState, setIdentityDocumentTypeState] = useState([]);
    const [dataBookingState, setDataBookingState] = useState({});
    const [listPhoneCodeState, setListPhoneCodeState] = useState([]);
    const [nameInputState, setNameInputState] = useState("");
    const [valueInputState, setValueInputState] = useState("");
    const [submitButtonLoaderActiveState, setSubmitButtonLoaderActiveState] = useState(false);
    const router = useRouter();
    const fromSelfCheckin = useFromSelfCheckin(router.location);

    // Affectation des données utilisateur si l'utilisateur précise que c'est lui
    useEffect(() => {
        if (!hasDataState) {
            if (identityState === "resident") {
                let user = globalContext.user;
                let formFieldUser = { ...user };
                formFieldUser.customerId = user.id;
                delete (formFieldUser.id);
                delete (formFieldUser.customerFileId);
                setFormFieldState(formFieldUser);
                if (user.country === globalContext.establishment.country) {
                    setTypeState("resident");
                } else {
                    setTypeState("nonResident");
                }
            } else {
                let resetedFormField = {};
                // eslint-disable-next-line no-unused-vars
                for (let key in formFieldState) {
                    resetedFormField[[key]] = "";
                }
                setFormFieldState(resetedFormField);
                setTypeState("");
            }
            handleStep(0);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [identityState, globalContext.establishment.country, globalContext.user, props.modalData]);

    useEffect(() => {
        if (paramModalState.stepNumber === 1 && props.modalData) {
            if (typeof props.listResa[props.indexResa] !== "undefined" && props.isBookerPax[props.listResa[props.indexResa].id]) {
                //reproduire result de chooseIdentity
                setIdentityState("roomingList");
                setParamModalState({ ...paramModalState, stepNumber: 2 });
            }
        }
    }, [paramModalState.stepNumber, props.indexResa, props.isBookerPax, props.modalData]);

    // Gestion des étapes et préremplissage des informations présente dans la roomingList
    useEffect(() => {
        if (paramModalState.stepNumber === 1) {
            setSegmentModalState(ChooseIdentity());
            setParamModalState({ ...paramModalState, active: "type" });
            setShowBtnProceedState(false);
            setShowBtnSubmitState(false);
        } else if (paramModalState.stepNumber === 2) {
            setSegmentModalState(FormModalCheckInPartOne());
            setParamModalState({ ...paramModalState, active: "identity" });
            setShowBtnProceedState(true);
            setShowBtnSubmitState(false);
        } else if (paramModalState.stepNumber === 3) {
            setSegmentModalState(FormModalCheckInPartTwo());
            setParamModalState({ ...paramModalState, active: "form" });
            setShowBtnProceedState(false);
            setShowBtnSubmitState(true);
        } else if (paramModalState.stepNumber > 3) {
            sendData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paramModalState.stepNumber, typeForFieldCheckInState]);

    // Détermination du type de formulaire pour le client en fonction de l'identité et du type
    useEffect(() => {
        setTypeForFieldCheckIn();
    }, [identityState, typeState]);

    useEffect(() => {
        if (nameInputState !== "") {
            if (nameInputState === 'country') {
                let formFieldTemp = Object.assign({}, formFieldState);

                formFieldTemp.country = valueInputState;

                if (formFieldTemp.nationality === '') {
                    formFieldTemp.nationality = valueInputState;
                }
                if (formFieldTemp.telephoneCode === '' || formFieldTemp.mobileCode === '' || formFieldTemp.language === '') {
                    if (globalContext.countries !== null && Object.entries(globalContext.countries).length > 0) {
                        let codeTel = '',
                            language = '';
                        for (let countrie of globalContext.countries) {
                            if (countrie.iso === valueInputState) {
                                codeTel = `${countrie.telephoneCode}__${valueInputState}`;
                                language = countrie.language;
                                break;
                            }
                        }

                        if (codeTel !== '') {
                            if (formFieldTemp.telephoneCode === '') {
                                formFieldTemp.telephoneCode = codeTel;
                            }
                            if (formFieldTemp.mobileCode === '') {
                                formFieldTemp.mobileCode = codeTel;
                            }
                            if (formFieldTemp.language === '') {
                                formFieldTemp.language = language;
                            }
                        }
                    }
                }

                setFormFieldState(formFieldTemp);
            } else {
                setFormFieldState({ ...formFieldState, [nameInputState]: valueInputState });
            }

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nameInputState, valueInputState]);

    // Récupération des informations utilisateur si celui-ci dit qu'il est présent et qu'il n'y a pas d'informations
    // présente dans la roomingList. Réinitialisation si changement en "autre"
    useEffect(() => {
        // Récupération des informations de la roomingList (si présente) a l'initialisation de la modal
        if (props.checkInFieldParameters !== undefined) {
            setListFieldCheckInState({ ...props.checkInFieldParameters });
        }
        if (props.listResa[props.indexResa] !== undefined) {
            setDataBookingState({ ...props.listResa[props.indexResa] });
        }
        if (props.listResa !== undefined && props.indexResa !== undefined && props.indexRooming !== undefined && props.listResa[props.indexResa] !== undefined && props.listResa[props.indexResa].roomingList !== undefined && props.listResa[props.indexResa].roomingList[props.indexRooming] !== undefined && startModalState) {
            let formFieldRoomingList = { ...props.listResa[props.indexResa].roomingList[props.indexRooming] };
            let formFieldCompleted = { ...formFieldRoomingList };
            formFieldCompleted.roomingId = formFieldRoomingList.id;
            formFieldCompleted.customerId = formFieldRoomingList.customerFileId;
            delete (formFieldCompleted.id);
            delete (formFieldCompleted.customerFileId);
            setFormFieldState(formFieldCompleted);
            setHasDataState(true);
            if (formFieldRoomingList.country === globalContext.establishment.country) {
                setTypeState("resident");
            } else {
                setTypeState("nonResident");
            }
            
            if (globalContext.user.id === formFieldCompleted.customerId) {
                setIdentityState("resident");
            } else {
                setIdentityState("roomingList");
            }

            setTypeForFieldCheckIn();

            setParamModalState({ ...paramModalState, active: "identity", stepNumber: 2 });
            setShowBtnProceedState(true);
            setShowBtnSubmitState(false);
            setStartModalState(false);
        } else {
            // let resetedFormField = {};
            // // eslint-disable-next-line no-unused-vars
            // for (let key in formFieldState){
            //     resetedFormField[[key]] = "";
            // }
            // setFormFieldState(resetedFormField);
            // setType("");
            setParamModalState({ ...paramModalState, active: "type", stepNumber: 1 });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [globalContext.establishment.country, props.checkInFieldParameters, props.indexResa, props.indexRooming, props.listResa, globalContext.user.id, props.modalData, props.booker]);

    // Initialisation pour select ListPays, Langue et IdentityDocument
    useEffect(() => {
        let listIndicatifTel = Utility.getListTelephoneCode(globalContext);
        setListPhoneCodeState(listIndicatifTel);
        let listPaysSelect = [];
        if (Array.isArray(globalContext.countries) === true) {
            for (let i = 0; i < globalContext.countries.length; i++) {
                if (Utility.testFlag(globalContext.countries[i].iso.toLowerCase()) === true) {
                    listPaysSelect.push({ key: globalContext.countries[i].iso, text: [<Flag name={globalContext.countries[i].iso.toLowerCase()} key={globalContext.countries[i].id + 'Flag'} />, globalContext.countries[i].name], value: globalContext.countries[i].iso });
                }
            }
            setListPaysState(listPaysSelect);
        }
        let identityDocumentTypeSelect = [];
        if (Array.isArray(globalContext.identityDocuments) === true) {
            globalContext.identityDocuments.map(typeIdentityPiece => (identityDocumentTypeSelect.push({
                key: typeIdentityPiece.id,
                text: typeIdentityPiece.name,
                value: typeIdentityPiece.id
            })));
            setIdentityDocumentTypeState(identityDocumentTypeSelect);
        }
        let languageSelect = [];
        if (Array.isArray(globalContext.languages) === true) {
            globalContext.languages.map(languague => (languageSelect.push({
                key: languague.id,
                text: [<Flag name={languague.iso.toLowerCase()}
                    key={languague.iso + 'Flag'} />, languague.originalName],
                value: languague.iso
            })));
            setListLanguageState(languageSelect);
        }
    }, [globalContext]);

    /**
     * 
     */
    const setTypeForFieldCheckIn = () => {
        if (identityState === "resident" && typeState === "resident") {
            setTypeForFieldCheckInState("resident");
        } else if (identityState === "roomingList" && typeState === "resident") {
            setTypeForFieldCheckInState("residentRooming");
        } else if (identityState === "resident" && typeState === "nonResident") {
            setTypeForFieldCheckInState("nonResident");
        } else {
            setTypeForFieldCheckInState("nonResidentRooming");
        }
    }

    // Gestion des étapes
    const handleStep = (stepNumber) => {
        let errorDetect = false;
        if (paramModalState.stepNumber === 2 || paramModalState.stepNumber === 3) {
            if (paramModalState.stepNumber === 2) {
                // eslint-disable-next-line no-unused-vars
                for (let property in errorInputPartOneState) {
                    if (errorInputPartOneState[property]) {
                        errorDetect = true;
                        break;
                    }
                }
            } else {
                // eslint-disable-next-line no-unused-vars
                for (let property in errorInputPartTwoState) {
                    if (errorInputPartTwoState[property]) {
                        errorDetect = true;
                        break;
                    }
                };
            }
        }
        
        if (errorDetect === false || paramModalState.stepNumber === 3) {
            if (stepNumber === 0) {
                if (paramModalState.stepNumber === 2 && (identityState === "" || typeState === "")) {
                    toast.error(globalContext.translations.modalCheckInAlertStepModal);
                } else {
                    setParamModalState({ ...paramModalState, stepNumber: paramModalState.stepNumber + 1 });
                }
            } else {
                if (stepNumber === 3 && (identityState === "" || typeState === "")) {
                    toast.error(globalContext.translations.modalCheckInAlertStepModal);
                } else if (paramModalState.stepNumber === 1 && stepNumber === 2 && identityState === "") {
                    toast.error(globalContext.translations.modalCheckInAlertStepModal);
                } else {
                    setParamModalState({ ...paramModalState, stepNumber });
                }
            }
        } else {
            toast.error(globalContext.translations.modalCheckInAlertErrorModal);
        }
    };

    // Gestion des inputs de la première partie du formulaire
    const handleReloadPartOne = (res) => {
        if(typeof res.target !== 'object') {
            let errorTemp = Object.assign({}, errorInputPartOneState);
            errorTemp[res.target] = res.error;
            setErrorInputPartOneState(errorTemp);
        }
    };

    // Gestion des inputs de la deuxième partie du formulaire
    const handleReloadPartTwo = (res) => {
        let errorTemp = Object.assign({}, errorInputPartTwoState);
        errorTemp[res.target] = res.error;
        setErrorInputPartTwoState(errorTemp);
    };

    // Gestion de la fermeture de la modal
    const handleClose = () => {
        document.body.classList.remove('modal-fade-in');
        props.setModalData(false);
        setHasDataState(false);
        setIdentityState("");
        setTypeState("");
        setStartModalState(true);
        setParamModalState({ stepNumber: 0, active: "type" });
    };

    // Gestion des inputs
    const handleChangeInput = (name, value) => {
        if (name === "country") {
            if (value === globalContext.establishment.country) {
                setTypeState("resident");
            } else {
                setTypeState("nonResident");
            }
        }
        setNameInputState(name);
        setValueInputState(value);
    };

    // Composant général de la modal
    const ModalPreCheckInData = () => {
        let btnProceed = (
            <Modal.Actions>
                <Button
                    form="formModal"
                    type="submit"
                    onClick={(e) => { handleReloadPartOne(e); handleStep(0) }}
                    primary
                    content={globalContext.translations.modalCheckInNextStep}
                    icon="chevron right"
                    labelPosition="right"
                    />
            </Modal.Actions>
        );
        let btnSubmit = (
            <Modal.Actions>
                <p style={{ textAlign: 'center', color: 'red' }}>{globalContext.translations.modalCheckInFormPartTwoMessageMandatory}</p>
                <Button
                    form="formModal"
                    type="submit"
                    loading={submitButtonLoaderActiveState}
                    disabled={submitButtonLoaderActiveState}
                    onClick={() => handleStep(0)}
                    primary
                    icon="chevron right"
                    content={globalContext.translations.modalCheckInBtnSubmit}
                    labelPosition="right"
                />
            </Modal.Actions>
        );
        let modalHeader = (
            <Modal.Header>
                <Header>
                    {globalContext.translations.modalCheckInBookingNumber} N° {dataBookingState.id}
                    <Header.Subheader>{globalContext.translations.modalCheckInFrom} <strong className="mbBlue"><MomentCustomer format="L">{dataBookingState.arrivalDate}</MomentCustomer></strong> {globalContext.translations.modalCheckInTo} <strong style={{ color: "#2185d0" }}><MomentCustomer format="L">{dataBookingState.departureDate}</MomentCustomer></strong></Header.Subheader>
                </Header>
            </Modal.Header>
        );
        let modalContent = (
            <Modal.Description>
                <Form id="formModal">
                    <Header>
                        {StepPreCheckIn()}
                    </Header>
                </Form>
            </Modal.Description>
        );
        let modalActions = "";
        if (showBtnProceedState) {
            modalActions = btnProceed
        } else if (showBtnSubmitState) {
            modalActions = btnSubmit
        }
        //<ModalTransition header={modalHeader} content={modalContent} open={props.modalData} size={} closeOnDimmerClick={} handleClose={handleClose}/>
        // return <TransitionablePortal
        //         open={props.modalData}
        //         transition={{
        //             animation: 'fly down',
        //             duration: 800,
        //         }}
        //         style={{padding: "0"}}
        //     >
        //     <Modal dimmer={true} open={props.modalData} onClose={() => handleClose()} closeIcon>
        //         <Modal.Header>
        //             <Header>
        //                 {globalContext.translations.modalCheckInBookingNumber} N° {dataBookingState.id}
        //                 <Header.Subheader>{globalContext.translations.modalCheckInFrom} <strong className="mbBlue"><MomentCustomer format="L">{dataBookingState.dateIn}</MomentCustomer></strong> {globalContext.translations.modalCheckInTo} <strong style={{color: "#2185d0"}}><MomentCustomer format="L">{dataBookingState.dateOut}</MomentCustomer></strong></Header.Subheader>
        //             </Header>
        //         </Modal.Header>
        //         <Modal.Content scrolling>
        //             <Modal.Description>
        //                 <Form id="formModal">
        //                     <Header>
        //                         {StepPreCheckIn()}
        //                     </Header>
        //                 </Form>
        //             </Modal.Description>
        //         </Modal.Content>
        //         {showBtnProceedState ? btnProceed : ""}
        //         {showBtnSubmitState ? btnSubmit : ""}
        //     </Modal>
        // </TransitionablePortal>
        return (
            <ModalTransition
                header={modalHeader}
                content={modalContent}
                actions={modalActions}
                open={props.modalData}
                size="large"
                handleClose={handleClose}
            />
        )
    };

    // Contenu de la troisième partie du formulaire
    const FormModalCheckInPartTwo = () => {
        let civilityField               = "",
            telephoneField              = "",
            mobileNumberField           = "",
            birthdateField              = "",
            birthPlaceField             = "",
            addressField                = "",
            postalCodeField             = "",
            cityField                   = "",
            nationalityField            = "",
            languageField               = "",
            identityDocumentField       = "",
            emptySecondaryInformations  = globalContext.translations.modalCheckInFormPartTwoEmptySecondaryInformations,
            currentListFieldCheckIn     = { ...listFieldCheckInState }[typeForFieldCheckInState];
        if (currentListFieldCheckIn) {
            if (currentListFieldCheckIn.qualite !== "deactivated") {
                emptySecondaryInformations = "";
                let required = currentListFieldCheckIn.qualite === "mandatory";
                civilityField = <InputSelect
                    label={globalContext.translations.modalCheckInFormPartTwoCivility}
                    name={formFieldPartTwo.civility.name}
                    value={formFieldState.civility}
                    data={Utility.getListCivility(globalContext.translations)}
                    labelError={globalContext.translations.modalCheckInFormPartTwoCivilityError}
                    handleChange={handleChangeInput}
                    required={required}
                    search={!isMobile}
                    flag
                />
            }
            if (currentListFieldCheckIn.tel !== "deactivated") {
                emptySecondaryInformations = "";
                let required = currentListFieldCheckIn.tel === "mandatory";
                telephoneField = <InputText
                    label={globalContext.translations.modalCheckInFormPartTwoPhoneNumber}
                    icon="phone"
                    iconPosition="left"
                    name={formFieldPartTwo.telephone.name}
                    value={formFieldState.telephone}
                    // select={{
                    //     name: formFieldPartTwo.telephoneCode.name,
                    //     value: formFieldState.telephoneCode,
                    //     data: listPhoneCodeState,
                    //     error: errorInputPartTwoState.telephoneCode
                    // }}
                    required={required}
                    labelError={globalContext.translations.modalCheckInFormPartTwoPhoneNumberError}
                    handleReload={handleReloadPartTwo}
                    handleChange={handleChangeInput}
                    typePattern={formFieldPartTwo.telephone.typePattern}
                    error={errorInputPartTwoState.telephone}
                />
            }
            if (currentListFieldCheckIn.mobile !== "deactivated") {
                emptySecondaryInformations = "";
                let required = currentListFieldCheckIn.mobile === "mandatory";
                mobileNumberField = <InputText
                    label={globalContext.translations.modalCheckInFormPartTwoMobileNumber}
                    icon="phone"
                    iconPosition="left"
                    name={formFieldPartTwo.mobile.name}
                    value={formFieldState.mobile}
                    select={{
                        name: formFieldPartTwo.mobileCode.name,
                        value: formFieldState.mobileCode,
                        data: listPhoneCodeState,
                        error: errorInputPartTwoState.mobileCode,
                        handleChangeSelect: handleChangeInput
                    }}
                    required={required}
                    labelError={globalContext.translations.modalCheckInFormPartTwoPhoneNumberError}
                    handleReload={handleReloadPartTwo}
                    handleChange={handleChangeInput}
                    typePattern={formFieldPartTwo.mobile.typePattern}
                    error={errorInputPartTwoState.mobile}
                />
            }
            if (currentListFieldCheckIn.date_naissance !== "deactivated") {
                emptySecondaryInformations = "";
                let required = currentListFieldCheckIn.date_naissance === "mandatory";
                birthdateField = <InputSelectDate
                    label={globalContext.translations.modalCheckInFormPartTwoBrithdate}
                    name={formFieldPartTwo.birthDate.name}
                    value={formFieldState.birthDate}
                    handleChange={handleChangeInput}
                    required={required}
                    search={!isMobile}
                />
            }
            if (currentListFieldCheckIn.lieu_naissance !== "deactivated") {
                emptySecondaryInformations = "";
                let required = currentListFieldCheckIn.lieu_naissance === "mandatory";
                birthPlaceField = <InputText
                    label={globalContext.translations.modalCheckInFormPartTwoBirthPlace}
                    name={formFieldPartTwo.birthPlace.name}
                    value={formFieldState.birthPlace}
                    required={required}
                    labelError={globalContext.translations.modalCheckInFormPartTwoBirthPlaceError}
                    handleReload={handleReloadPartTwo}
                    handleChange={handleChangeInput}
                    typePattern={formFieldPartTwo.birthPlace.typePattern}
                    error={errorInputPartTwoState.birthPlace}
                />
            }
            if (currentListFieldCheckIn.ad1 !== "deactivated") {
                emptySecondaryInformations = "";
                let required = currentListFieldCheckIn.ad1 === "mandatory";
                addressField = (
                    <div>
                        <InputText
                            label={globalContext.translations.modalCheckInFormPartTwoAddress}
                            name={formFieldPartTwo.firstAddress.name}
                            value={formFieldState.firstAddress}
                            required={required}
                            labelError={globalContext.translations.modalCheckInFormPartTwoAddressError}
                            handleReload={handleReloadPartTwo}
                            handleChange={handleChangeInput}
                            typePattern={formFieldPartTwo.firstAddress.typePattern}
                            error={errorInputPartTwoState.firstAddress}
                        />
                        <InputText
                            label={globalContext.translations.modalCheckInFormPartTwoSecondAddress}
                            name={formFieldPartTwo.secondaryAddress.name}
                            value={formFieldState.secondaryAddress}
                            required={false}
                            handleReload={handleReloadPartTwo}
                            handleChange={handleChangeInput}
                            typePattern={formFieldPartTwo.secondaryAddress.typePattern}
                            error={false}
                        />
                        <InputText
                            label={globalContext.translations.modalCheckInFormPartTwoThirdAddress}
                            name={formFieldPartTwo.thirdAddress.name}
                            value={formFieldState.thirdAddress}
                            required={false}
                            handleReload={handleReloadPartTwo}
                            handleChange={handleChangeInput}
                            typePattern={formFieldPartTwo.thirdAddress.typePattern}
                            error={false}
                        />
                    </div>
                )
            }
            if (currentListFieldCheckIn.cp !== "deactivated") {
                emptySecondaryInformations = "";
                let required = currentListFieldCheckIn.cp === "mandatory";
                postalCodeField = <InputText
                    label={globalContext.translations.modalCheckInFormPartTwoPostalCode}
                    name={formFieldPartTwo.zipCode.name}
                    value={formFieldState.zipCode}
                    required={required}
                    labelError={globalContext.translations.modalCheckInFormPartTwoPostalCodeError}
                    handleReload={handleReloadPartTwo}
                    handleChange={handleChangeInput}
                    typePattern={formFieldPartTwo.zipCode.typePattern}
                    error={errorInputPartTwoState.zipCode}
                />
            }
            if (currentListFieldCheckIn.ville !== "deactivated") {
                emptySecondaryInformations = "";
                let required = currentListFieldCheckIn.ville === "mandatory";
                cityField = <InputText
                    label={globalContext.translations.modalCheckInFormPartTwoCity}
                    name={formFieldPartTwo.city.name}
                    value={formFieldState.city}
                    required={required}
                    labelError={globalContext.translations.modalCheckInFormPartTwoCityError}
                    handleReload={handleReloadPartTwo}
                    handleChange={handleChangeInput}
                    typePattern={formFieldPartTwo.city.typePattern}
                    error={errorInputPartTwoState.city}
                />
            }
            if (currentListFieldCheckIn.nationalite !== "deactivated") {
                emptySecondaryInformations = "";
                let required = currentListFieldCheckIn.nationalite === "mandatory";
                nationalityField = <InputSelect
                    label={globalContext.translations.modalCheckInFormPartTwoSelectNationality}
                    name={formFieldPartTwo.nationality.name}
                    value={formFieldState.nationality}
                    data={countriesState}
                    labelError={globalContext.translations.modalCheckInFormPartTwoSelectNationalityError}
                    handleChange={handleChangeInput}
                    required={required}
                    search={!isMobile}
                    flag
                />
            }
            if (currentListFieldCheckIn.id_langue_fich_client !== "deactivated") {
                emptySecondaryInformations = "";
                let required = currentListFieldCheckIn.id_langue_fich_client === "mandatory";
                languageField = <InputSelect
                    label={globalContext.translations.modalCheckInFormPartTwoLanguage}
                    name={formFieldPartTwo.language.name}
                    value={formFieldState.language}
                    data={listLanguageState}
                    labelError={globalContext.translations.modalCheckInFormPartTwoLanguageError}
                    handleChange={handleChangeInput}
                    required={required}
                    search={!isMobile}
                    flag
                />
            }
            if (currentListFieldCheckIn.id_type_piece_identite !== "deactivated") {
                emptySecondaryInformations = "";
                let required = currentListFieldCheckIn.id_type_piece_identite === "mandatory";
                identityDocumentField = (
                    <div>
                        <InputSelect
                            label={globalContext.translations.modalCheckInFormPartTwoIdentityDocumentType}
                            name={formFieldPartTwo.identityDocumentId.name}
                            value={formFieldState.identityDocumentId}
                            data={identityDocumentIdState}
                            labelError={globalContext.translations.modalCheckInFormPartTwoIdentityDocumentTypeError}
                            handleChange={handleChangeInput}
                            required={required}
                            search={!isMobile}
                            flag
                        />
                        <InputText
                            label={globalContext.translations.modalCheckInFormPartTwoIdentityDocumentNumber}
                            name={formFieldPartTwo.identityDocument.name}
                            value={formFieldState.identityDocument}
                            required={required}
                            labelError={globalContext.translations.modalCheckInFormPartTwoIdentityDocumentNumberError}
                            handleReload={handleReloadPartTwo}
                            handleChange={handleChangeInput}
                            typePattern={formFieldPartTwo.identityDocument.typePattern}
                            error={errorInputPartTwoState.identityDocument}
                        />
                    </div>
                )
            }
        }

        return (
            <div>
                <div>
                    <p>{globalContext.translations.modalCheckInFormPartTwoTitle} : </p>
                    {civilityField}
                    {telephoneField}
                    {mobileNumberField}
                    {birthdateField}
                    {birthPlaceField}
                    {addressField}
                    {postalCodeField}
                    {cityField}
                    {nationalityField}
                    {languageField}
                    {identityDocumentField}
                    {emptySecondaryInformations}
                    {/*{signatureField}*/}
                    {/*{categoryField}*/}
                </div>
            </div>
        )
    };

    // Première partie du formulaire pour déterminer quels champs afficher
    const FormModalCheckInPartOne = () => {
        let required = false,
            currentListFieldCheckIn = { ...listFieldCheckInState }[typeForFieldCheckInState];

        required = currentListFieldCheckIn.nom === "mandatory";
        let lastNameField = <InputText
            label={globalContext.translations.modalCheckInFormPartOneLastname}
            name={formFieldPartOne.lastName.name}
            value={formFieldState.lastName}
            required={required}
            labelError={globalContext.translations.modalCheckInFormPartOneLastnameError}
            handleReload={handleReloadPartOne}
            handleChange={handleChangeInput}
            typePattern={formFieldPartOne.lastName.typePattern}
            error={errorInputPartOneState.lastName}
        />
        required = currentListFieldCheckIn.prenom === "mandatory";
        let firstNameField = <InputText
            label={globalContext.translations.modalCheckInFormPartOneFirstname}
            name={formFieldPartOne.firstName.name}
            value={formFieldState.firstName}
            required={required}
            labelError={globalContext.translations.modalCheckInFormPartOneFirstnameError}
            handleReload={handleReloadPartOne}
            handleChange={handleChangeInput}
            typePattern={formFieldPartOne.firstName.typePattern}
            error={errorInputPartOneState.firstName}
        />
        required = currentListFieldCheckIn.email === "mandatory";
        let emailField = <InputText
            type="email"
            label={globalContext.translations.modalCheckInFormPartOneEmail}
            name={formFieldPartOne.mail.name}
            value={formFieldState.mail}
            required={required}
            labelError={globalContext.translations.modalCheckInFormPartOneEmailError}
            handleReload={handleReloadPartOne}
            handleChange={handleChangeInput}
            typePattern={formFieldPartOne.mail.typePattern}
            error={errorInputPartOneState.mail}
            //typePattern="email"
        />
        return (
            <div>
                <p>{globalContext.translations.modalCheckInFormPartOneTitle} : </p>
                <div>
                    {lastNameField}
                    {firstNameField}
                    {emailField}
                    <InputSelect
                        label={globalContext.translations.modalCheckInFormPartOneSelectCountry}
                        name={formFieldPartOne.country.name}
                        value={formFieldState.country}
                        data={countriesState}
                        labelError={globalContext.translations.modalCheckInFormPartOneSelectCountryError}
                        handleReload={handleReloadPartOne}
                        handleChange={handleChangeInput}
                        required
                        search={!isMobile}
                        flag
                    />
                </div>
            </div>
        )
    };

    // Choix de l'identité pour déterminer la suite du formulaire
    const ChooseIdentity = () => {
        let colorRoomingList = (identityState === "roomingList") ? "blue" : null;
        let colorReserveur = (identityState === "resident") ? "blue" : null;

        return (
            <div style={{ textAlign: 'center' }}>
                <p>{globalContext.translations.modalCheckInIdentityTitle} ?</p>
                <Button.Group size="massive">
                    <Button
                        type="button"
                        onClick={() => {
                            setIdentityState("resident");
                        }}
                        color={colorReserveur}
                    >
                        {globalContext.translations.modalCheckInIdentityMe}
                    </Button>
                    <Button.Or text={globalContext.translations.modalCheckInIdentityOr} />
                    <Button
                        type="button"
                        onClick={() => {
                            setIdentityState("roomingList");
                        }}
                        color={colorRoomingList}
                    >
                        {globalContext.translations.modalCheckInIdentityOther}
                    </Button>
                </Button.Group>
            </div>
        );
    };

    // Composant des étapes
    const StepPreCheckIn = () => {
        let divided = !hasDataState ? 3 : 2;
        let firstStep = !hasDataState ? (
            <Step active={paramModalState.active === "type"} onClick={() => handleStep(1)}>
                <Icon name="user" />
                <Step.Content>
                    <Step.Title>{globalContext.translations.modalCheckInStepOneTitle}</Step.Title>
                    <Step.Description>{globalContext.translations.modalCheckInStepOneMessage}</Step.Description>
                </Step.Content>
            </Step>
        )
            : "";
        let content = (
            <Step.Group attached="top" widths={divided}>
                {/*{firstStep}*/}
                {props.isBookerPax?.[props.listResa?.[props.indexResa]?.id] ? null : firstStep}
                <Step active={paramModalState.active === "identity"} onClick={() => handleStep(2)}>
                    <Icon name="info" />
                    <Step.Content>
                        <Step.Title>{globalContext.translations.modalCheckInStepTwoTitle}</Step.Title>
                        <Step.Description>{globalContext.translations.modalCheckInStepTwoMessage}</Step.Description>
                    </Step.Content>
                </Step>
                <Step active={paramModalState.active === "form"} onClick={() => handleStep(3)}>
                    <Icon name="info" />
                    <Step.Content>
                        <Step.Title>{globalContext.translations.modalCheckInStepThreeTitle}</Step.Title>
                        <Step.Description>{globalContext.translations.modalCheckInStepThreeMessage}</Step.Description>
                    </Step.Content>
                </Step>
            </Step.Group>
        );
        return (
            <div>
                <Segment children={content} />
                <Segment style={{ width: "100%" }} attached>
                    {segmentModalState}
                </Segment>
            </div>
        )
    };

    // Ajax des données d'ajout/modification
    const sendData = () => {
        let dataToSend = {
            bookingId: dataBookingState.id,
            bookingFolderId: parseInt(props.bookingFolderId),
            customerFile: { ...formFieldState },
            isFromSelfCheckin: fromSelfCheckin.isFromSelfCheckin
        };
        //console.log( 'modal' );
        dataToSend.customerFile.identityDocumentId = parseInt(dataToSend.customerFile.identityDocumentId);
        delete (dataToSend.customerFile.bookingId);
        delete (dataToSend.customerFile.gdprAgreement);
        delete (dataToSend.customerFile.mailing);
        if (dataToSend.customerFile.customerId === undefined) {
            dataToSend.customerFile.customerId = 0;
        }
        if (dataToSend.customerFile.roomingId === undefined) {
            dataToSend.customerFile.roomingId = 0;
        }
        //dataToSend.isFromSelfCheckin = fromSelfCheckin.isFromSelfCheckin;

        setSubmitButtonLoaderActiveState(true)

        API
            .post(Utility.getUrlAjax() + '/addPreCheckInAction', JSON.stringify(dataToSend))
            .then(res => {
                handleClose();
                ResponseManagement(res,
                    () => {
                        if (res.data.data.completionRates) {
                            // MAJ DU STORE BOOKING COMPLETION RATES
                            if (res.data.data.completionRates?.byFolder && res.data.data.completionRates.byFolder?.[dataToSend.bookingFolderId]) {
                                if (res.data.data.completionRates.byFolder[dataToSend.bookingFolderId]?.byBooking) {
                                    //maj sotre booking completion rate
                                    props.updateBookingsCompletionRate({
                                        bookingsCompletionRates: {
                                          bookingsCompletionRates: res.data.data.completionRates.byFolder[dataToSend.bookingFolderId].byBooking
                                        },
                                        currentBookingId: dataToSend.bookingId,
                                        isFromSelfCheckin: fromSelfCheckin.isFromSelfCheckin
                                    });
                                }
                            }
                        }
                        
                        let processedData = props.handleData(res.data.data);
                        if (processedData.checkInFieldParameters) {
                            props.setCheckInFieldParameters(processedData.checkInFieldParameters);
                        }
                        if (processedData.booker && processedData.customerFiles) {
                            let bookerData = processedData.customerFiles.find(customerFile => parseInt(customerFile.id) === parseInt(processedData.booker));
                            if (bookerData !== undefined) {
                                dispatch({ type: GlobalType.SET_USER, payload: bookerData });
                            }
                        }
                        if (processedData.bookings) {
                            props.handleReloadData(processedData);
                            props.setListResa(processedData.bookings);
                        }
                        if (processedData.isBookerPax) {
                            props.updateIsBookerPax(processedData.isBookerPax);
                        }
                        setSubmitButtonLoaderActiveState(false);
                        toast.success(globalContext.translations.modalCheckInAlertSuccessModal);
                    },
                    () => {
                        if (res.data.message !== "") {
                            if (typeof globalContext.translations[res.data.message] !== 'undefined') {
                                toast.error(globalContext.translations[res.data.message])
                            } else {
                                toast.error(res.data.message)
                            }
                        } else {
                            toast.error('Data sending error');
                        }

                        
                        var timeOut = setTimeout(() => {
                            setSubmitButtonLoaderActiveState(false);
                            clearTimeout(timeOut);
                            props.setIsRedirectState(true);
                        }, 5500);
                    }
                );
            })
            .catch(error => {
                console.error(error);
                ErrorManagement(error, () => {
                    var timeOut = setTimeout(() => {
                        setSubmitButtonLoaderActiveState(false);
                        clearTimeout(timeOut);
                        props.setIsRedirectState(true);
                    }, 5500);
                }, globalContext.translations);
            })
    };

    return (
        <div>
            {ModalPreCheckInData()}
        </div>
    )
};

export default connect(mapProps, mapDispatch)(ModalPreCheckIn);